import React, { useEffect, useState } from 'react';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { handleSubmitSelection, openModal, closeModal } from './figma.util.js';
import { toast } from 'react-toastify';
import CustomLoader from '../../common/CustomLoader.js';

const FigmaGetImage = ({
  projectId,
  version,
  figmaImageData,
  systemRoles,
  history,
  userPrompt,
  roles,
  generateFigmaLayouts,
}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [loading, setLoading] = useState(null);

  const toggleImageSelection = (image) => {
    if (!systemRoles.length) {
      toast.error("You can't select an image for layout.");
      return;
    }

    if (selectedImage && selectedImage.id === image.id) {
      setSelectedImage(null);
    } else {
      setSelectedImage(image);
    }

    closeModal(setShowModal, setCurrentImage);
  };
  useEffect(() => {}, [systemRoles]);

  if (loading) {
    return (
      <div className="row justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <div className="col-12 text-center">
          <div className="justify-content-center align-items-center py-5">
            <div>
              <CustomLoader loading={true} size="20px" color="#303453" />
            </div>
            <div className="text-center">
              <p className="mt-3 font-weight-bold text-center">
                Please wait while we are generating Layout for your application...
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {figmaImageData.length > 0 && <h3>Select frame for layout</h3>}
        <div className="row g-3">
          {figmaImageData.map((data) => (
            <div key={data.id} className="col-6 col-md-4 col-lg-3">
              <div
                className={`card ${
                  selectedImage && selectedImage.id === data.id
                    ? 'border-success border-3 shadow'
                    : ''
                }`}
                onClick={() =>
                  systemRoles.length > 0 && openModal(data, setCurrentImage, setShowModal)
                }
                style={{
                  cursor: systemRoles.length > 0 ? 'pointer' : 'not-allowed',
                  transition: '0.2s ease-in-out',
                }}
              >
                <img
                  src={data.image}
                  alt={data.name}
                  className="card-img-top"
                  style={{ height: '150px', objectFit: 'cover' }}
                />
                <div className="card-body text-center">
                  <p className="card-text">{data.name}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedImage && (
          <div className="d-flex justify-content-end mt-4">
            <button
              type="submit"
              className="btn btn-theme-submit btn-md"
              onClick={() =>
                handleSubmitSelection(
                  setSelectedImage,
                  [selectedImage],
                  projectId,
                  version,
                  history,
                  systemRoles,
                  setLoading,
                  userPrompt,
                  roles,
                  generateFigmaLayouts,
                )
              }
              style={{ whiteSpace: 'nowrap' }}
            >
              <i className="wb webconnect-rocket"></i> &nbsp;Generate Layout
            </button>
          </div>
        )}
      </div>

      {showModal && currentImage && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          onClick={() => closeModal(setShowModal, setCurrentImage)}
        >
          <div
            className="modal-dialog modal-lg mt-5 modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-body text-center">
                <img
                  src={currentImage.image}
                  alt={currentImage.name}
                  className="img-fluid"
                  style={{ maxHeight: '60vh', objectFit: 'contain' }}
                />
                <p className="mt-2">{currentImage.name}</p>
              </div>
              <div className="modal-footer">
                <button
                  className={`btn ${
                    selectedImage && selectedImage.id === currentImage.id
                      ? 'btn-theme-delete'
                      : 'btn-theme-submit'
                  }`}
                  onClick={() => toggleImageSelection(currentImage)}
                >
                  {selectedImage && selectedImage.id === currentImage.id ? (
                    <>
                      <i className={`wb ${drapcodeIcon('go')}`}></i>&nbsp;Deselect&nbsp;
                    </>
                  ) : (
                    <>
                      <i className={`wb ${drapcodeIcon('select')}`}></i>&nbsp;Select&nbsp;
                    </>
                  )}
                </button>
                <button
                  className="btn ml-2"
                  onClick={() => closeModal(setShowModal, setCurrentImage)}
                >
                  <i className={`wb ${drapcodeIcon('closeModal')}`}></i>&nbsp;Close&nbsp;
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FigmaGetImage;
